import { render, staticRenderFns } from "./PressureChart.vue?vue&type=template&id=c890b162&scoped=true&"
import script from "./PressureChart.vue?vue&type=script&lang=js&"
export * from "./PressureChart.vue?vue&type=script&lang=js&"
import style0 from "./PressureChart.vue?vue&type=style&index=0&id=c890b162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c890b162",
  null
  
)

export default component.exports